import { render, staticRenderFns } from "./TwProcessList.vue?vue&type=template&id=5ed511cc&scoped=true&"
import script from "./TwProcessList.vue?vue&type=script&lang=js&"
export * from "./TwProcessList.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessList.vue?vue&type=style&index=0&id=5ed511cc&lang=scss&scoped=true&"
import style1 from "./TwProcessList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed511cc",
  null
  
)

export default component.exports